import {
    queryTask,
    queryAsyncOrderResultTask,
    getProgress,
    getUpsertPlatformBySupplierOnlineGoodsProcess,
    queryAsyncPayResultTask,
    queryAsyncFastRefundTask,
    queryAfterSaleRefundTaskProgress
} from '@/services/progress'
import {
    MANUALLY_PULL_ORDERS,
    BATCH_SHARE_GOODS,
    EXPORT_BREAK_ORDER,
    EXPORT_BREAK_GOODS,
    SUPPLIER_ONLINE_ITEM_IMPORT,
    OP_PAYMENT_DETAILS_EXPORT,
    FAST_REFUND_ASYNC,
    SHOP_GOODS_BATCH_EXPORT_BY_SKU,
    CREATE_ADDRESS_STRATEGY_TASK,
    AFTER_SALE_ONLY_REFUND_TASK,
    AFTER_SALE_AGREE_RETURN_TASK,
    AFTER_SALE_AGREE_RETURN_REFUND_TASK
} from '@/modules/globals/constants/messageCenter'
import { queryTask as importQueryTask } from '@/services/erpGoodsImport'
import { queryExportData as exportShopGoodsBySku } from '@/services/goods'
import { getTaskProgress } from '@/services/afterSale'

export const queryTaskFn = (messageType: string) => {
    if (messageType === MANUALLY_PULL_ORDERS) {
        return queryAsyncOrderResultTask
    }
    if (messageType === BATCH_SHARE_GOODS) {
        return importQueryTask
    }
    if (messageType === SUPPLIER_ONLINE_ITEM_IMPORT) {
        return getUpsertPlatformBySupplierOnlineGoodsProcess
    }
    if (messageType === OP_PAYMENT_DETAILS_EXPORT) {
        return queryAsyncPayResultTask
    }
    if (messageType === SHOP_GOODS_BATCH_EXPORT_BY_SKU) {
        return exportShopGoodsBySku
    }
    if (messageType === FAST_REFUND_ASYNC) {
        return queryAsyncFastRefundTask
    }
    if (messageType === EXPORT_BREAK_ORDER || messageType === EXPORT_BREAK_GOODS) {
        return ({ taskId }) => {
            return new Promise((resolve, reject) => {
                getProgress(taskId)
                    .then(response => {
                        resolve({
                            ...response,
                            data: {
                                ...response.data,
                                taskState: response?.data?.finished ? 'end' : 'process'
                            }
                        })
                    })
                    .catch(reject)
            })
        }
    }

    if (
        [AFTER_SALE_ONLY_REFUND_TASK, AFTER_SALE_AGREE_RETURN_TASK, AFTER_SALE_AGREE_RETURN_REFUND_TASK].includes(
            messageType
        )
    ) {
        return queryAfterSaleRefundTaskProgress
    }
    if (messageType === CREATE_ADDRESS_STRATEGY_TASK) {
        return ({ taskId }) => {
            return new Promise((resolve, reject) => {
                getTaskProgress({ taskId })
                    .then(response => {
                        resolve({
                            ...response,
                            data: {
                                ...response.data,
                                ...(response.data?.result || {}),
                                taskState: response?.data?.curProcess === 100 ? 'end' : 'process'
                            }
                        })
                    })
                    .catch(reject)
            })
        }
    }

    return queryTask
}
const afterSaleTypeMap: { [key: string]: string } = {
    [AFTER_SALE_ONLY_REFUND_TASK]: '仅退款',
    [AFTER_SALE_AGREE_RETURN_TASK]: '同意退货',
    [AFTER_SALE_AGREE_RETURN_REFUND_TASK]: '退货退款'
}
export const getExtraParams = (messageType: string) => {
    if (
        [AFTER_SALE_ONLY_REFUND_TASK, AFTER_SALE_AGREE_RETURN_TASK, AFTER_SALE_AGREE_RETURN_REFUND_TASK].includes(
            messageType
        )
    ) {
        return {
            afterSaleType: afterSaleTypeMap[messageType]
        }
    }
    return {}
}
